import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductCore } from "../types/products";

const API = process.env.REACT_APP_API;

/**
 * Hook para buscar um produto específico do catálogo (core.Product)
 */
const useCoreProduct = (id: number) => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["core_product", id],
    queryFn: () => {
      return fetch(`${API}/api/semeadora/core_products/${id}/`, {
        method: "GET",
      }) as Promise<IProductCore>;
    },
    enabled: !!id,
    onError: (error) => {
      console.error("Erro ao buscar core_product", error);
    },
  });
};

export default useCoreProduct;
